module.exports = __webpack_public_path__ + "static/media/news-sphp-apti-partnership.d3c2fc4b.jpg";